import useOrderBundleItem, { useOrderBundleItemForm } from '@hooks/useOrderBundleItem'

import type {
  OrderBundleItemModel,
  ProviderPriceListItemModel,
  ProviderPriceListItemOptionModel,
  ProviderPriceListModel,
  ServiceProductModel,
} from '@models/types'

type MapState = {
  selectedItem: ProviderPriceListItemModel,
  selectedOptions: ProviderPriceListItemOptionModel[],
  selectedPriceList: ProviderPriceListModel,
  selectedProduct: ServiceProductModel,
}

type OrderBundleItemParams = {
  options: object,
  order_bundle_id: number,
  provider_id: number,
  provider_price_list_id: number,
  provider_price_list_item_id: number,
  service_id: number,
  service_product_id: number,
  title: string,
}

const mapStateToEntityState = (state: MapState, order_bundle_id: number) => {
  const {
    selectedItem,
    selectedOptions,
    selectedPriceList,
    selectedProduct,
  } = state

  const orderBundleItemParams: OrderBundleItemParams = {
    options: selectedOptions,
    order_bundle_id,
    provider_id: selectedPriceList.provider_id,
    provider_price_list_id: selectedPriceList.id,
    provider_price_list_item_id: selectedItem.id,
    service_id: selectedProduct.service_id,
    service_product_id: selectedProduct.id,
    title: selectedProduct.title,
  }

  return orderBundleItemParams
}

type UseCreateOrEditOrderBundleItemParams = {
  orderBundleItem: OrderBundleItemModel,
  state : MapState,
}

const useCreateOrEditOrderBundleItemModal = (params: UseCreateOrEditOrderBundleItemParams) => {
  const {
    orderBundleItem, state,
  } = params

  const isNewRecord = !orderBundleItem.id

  const { order_bundle_id } = orderBundleItem
  const {
    selectedItem,
    selectedOptions,
    selectedPriceList,
    selectedProduct,
  } = state

  const {
    callbacks: {
      createOrderBundleItem,
      updateOrderBundleItem,
    },
    creating,
    updating,
  } = useOrderBundleItem(orderBundleItem)

  const orderBundleItemForm = useOrderBundleItemForm(orderBundleItem, { validateOn: 'change' })

  const { saveEnabled: formSaveEnabled } = orderBundleItemForm

  const saveEnabled = isNewRecord ? !!(
    selectedPriceList?.id
    && selectedProduct.id
    && selectedItem.id
    && selectedItem.options?.length === selectedOptions.length
  ) : formSaveEnabled

  return {
    callbacks: {
      createOrderBundleItem,
      mapStateToEntityState: () => mapStateToEntityState(state, order_bundle_id),
      updateOrderBundleItem,
    },
    isNewRecord,
    loading: creating || updating,
    orderBundleItemForm,
    saveEnabled,
  }
}

export default useCreateOrEditOrderBundleItemModal
